import {
  queryClientOptions,
  type UseAppQueryOptions
} from '@libs/data-access/queries'
import { useQuery } from '@tanstack/react-query'

import type { FetchScheduleMembershipOptions } from '../scheduleMembership.api'
import { fetchScheduleMembershipById } from '../scheduleMembership.api'
import { scheduleMembershipQueryKeys } from '../scheduleMembership.cacheKeys'
import type { ScheduleMembershipSchema } from '../scheduleMembershipService'

export const useFetchScheduleMembership = (
  request: FetchScheduleMembershipOptions,
  queryOptions?: UseAppQueryOptions<ScheduleMembershipSchema>
) =>
  useQuery({
    ...queryOptions,
    queryKey: scheduleMembershipQueryKeys.scheduleMembership(
      request?.pathParams.membership_id
    ),
    queryFn: () => fetchScheduleMembershipById(request),
    staleTime: queryClientOptions.time.STATIC
  })
